import React from "react";
import Content from "../sections/Verifyotp/Content";

export const VerifyOtp = (props) => {
  return (
    <div className="ms-body ms-primary-theme ms-logged-out">
      <main className="body-content">
        <Content />
      </main>
    </div>
  );
};

export default VerifyOtp;
